export default __webpack_public_path__ + "static/media/invoice2.d7ebf5d8.svg";